import { render, staticRenderFns } from "./ImportExportCredentials.vue?vue&type=template&id=b27ddd82"
import script from "./ImportExportCredentials.vue?vue&type=script&lang=js"
export * from "./ImportExportCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports